   // messagePlugin.js
   export default {
    install(app) {
      app.config.globalProperties.$toast = {
        showMarkLoading() {
          app.config.globalProperties.$eventBus.emit('show-loading');
        },
        hideMarkLoading() {
          app.config.globalProperties.$eventBus.emit('hide-loading');
        },
        showToast({ message, status = 'info', timeout = 3000, callback = null, position = 'center' }) {
          app.config.globalProperties.$eventBus.emit('show-snackbar', message, status, timeout, position);
          if (callback && typeof callback === 'function') {
            setTimeout(() => {
              callback();
            }, timeout);
          }
        },
        success(message, timeout = 3000, position = 'center') {
          app.config.globalProperties.$eventBus.emit('show-snackbar', message, 'success', timeout, position);
        },
        error(message, timeout = 3000, position = 'center') {
          app.config.globalProperties.$eventBus.emit('show-snackbar', message, 'error', timeout, position);
        },
        warning(message, timeout = 3000, position = 'center') {
          app.config.globalProperties.$eventBus.emit('show-snackbar', message, 'warning', timeout, position);
        },
        info(message, timeout = 3000, position = 'center') {
          app.config.globalProperties.$eventBus.emit('show-snackbar', message, 'info', timeout, position);
        }
      };
    }
  };